var parent = require('../../stable/symbol');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-app-polyfill/node_modules/core-js/actual/symbol/index.js
// module id = 1200
// module chunks = 1